import React from 'react';

function ShopIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="25"
      fill="none"
      viewBox="0 0 24 25"
    >
      <g>
        <path
          fill="#FF8A00"
          d="M18.715 10.026c-.095-1.705-1.424-3.031-3.038-3.126-.474-2.084-2.183-3.6-4.177-3.6-1.994 0-3.703 1.516-4.082 3.6-1.71.095-3.038 1.516-3.133 3.126L4 17.795c0 .947.285 1.8.95 2.463.569.663 1.423 1.042 2.373 1.042h8.354c.95 0 1.804-.379 2.374-1.042.664-.663.949-1.516.949-2.463l-.285-7.769zM11.5 5.1c1.044 0 1.899.758 2.184 1.8H9.316c.285-1.042 1.14-1.8 2.184-1.8zm5.221 13.832c-.284.284-.664.473-1.044.473H7.323c-.38 0-.76-.19-1.045-.473-.284-.285-.38-.663-.38-1.042l.286-7.769c0-.663.474-1.137 1.139-1.326v.852c0 .474.38.948.95.948.569 0 .949-.38.949-.948V8.7h4.746v.947c0 .474.38.948.95.948s.95-.38.95-.948v-.852c.474.19.949.663.949 1.326l.284 7.769c0 .378-.095.757-.38 1.042z"
        ></path>
      </g>
    </svg>
  );
}

export default ShopIcon;
